<div class="default-dialog-wrapper">
  <div class="flex flex-row content">
    <div class="flex flex-col w-100-percent">
      <div class="flex flex-row w-100-percent">
        <h1 class="flex flex-wrap basis-full mat-headline-5 mb-8 fw-600 mr-98">{{title}}</h1>
        <mat-icon svgIcon="close" class="flex justify-end cursor-pointer icon-lg" [matDialogClose]="false"></mat-icon>
      </div>
      <div class="subtitle mb-10">
        {{subTitle}}
      </div>
      <mat-divider class="w-100-percent mb-24"></mat-divider>
      <div class="columns flex-grow">
        <ng-container *ngFor="let column of updateColumns">
          <div *ngIf="column.name" class="mb-12">
            <mat-slide-toggle class="ml-8" [checked]="column.visible" [disabled]="column.disable"
              (change)="updateValue($event, column.key)"></mat-slide-toggle>
            <span class="pl-8 fw-500 column-title">{{column.name}}</span>
          </div>
        </ng-container>
      </div>
      <mat-divider class="full-width-divider neutral-column w-100-percent mt-4 mb-4"></mat-divider>
      <div class="flex justify-end gap-4 mt-auto px-6 py-4 border-t">
        <button class="white mr-12 border-none" (click)="cancel()">{{'DIALOG.CANCEL'| transloco}}</button>
        <button class="accent" (click)="update()"
          [ngClass]="{'disabled': !columnUpdated}">{{confirmButtonText}}</button>
      </div>
    </div>
  </div>
</div>